import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import { constant, debounce } from 'lodash';
import { GeneralService } from 'src/app/api/config/general.service';
import { HotelService } from 'src/app/api/tourism/hotel.service';
import * as _ from 'underscore';
declare var $: any;

@Component({
  selector: 'component-search-airport',
  templateUrl: './search-airport.component.html',
  styleUrls: ['./search-airport.component.css']
})
export class SearchAirportComponent implements OnInit {
  @ViewChild('searchInput') searchInput: any;
  @Output() selectedAirportEvent = new EventEmitter<string>();
  @Input() classSize: string | null = null;

  data = [];
  // keyword = 'name';
  keyword = 'fullname_str';
  isTypedSearch = false;
  classSearch: any;

  constructor(
    private hotelService: HotelService,
    private generalService: GeneralService
  ) {}

  ngOnInit() {
    this.classSearch = this.classSize;
  }

  debouncedSearchInput = debounce(event => this.getSearchHotels(event), 250);

  getSearchHotels(search_: any) {
    this.isTypedSearch = true;
    if (search_.length > 1) {
      let val_params = 'search=' + search_;
      this.generalService.searchAirport(val_params).subscribe({
        next: (data: any) => {
          this.data = data.results;
          this.data.map((item:any) => item.fullname_str = `${item.name} ${item.city}`);
        }
      });
    } else {
      this.data = [];
    }
  }

  selectSearchHotel(item: any) {
    setTimeout(() => {
      (<any>$('.autocomplete-overlay')).hide();
      (<any>$('.autocomplete-container .not-found')).hide();
    }, 10);

    // this.closedSearchPanel();
    this.selectedAirportEvent.emit(item);
    this.data = [];
    this.searchInput.clear();
    this.searchInput.focus();
  }

  closedSearchPanel(): void {
    this.data = [];
    this.isTypedSearch = false;
    setTimeout(() => {
      (<any>$('.autocomplete-overlay')).hide();
    }, 10);
  }

  clearedInputSearch(): void {
    this.searchInput.focus();
    this.data = [];
    this.isTypedSearch = false;
    setTimeout(() => {
      (<any>$('.autocomplete-overlay')).hide();
    }, 10);
  }

  focused() {
    this.searchInput.focus();
  }
}
